import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import React, { useState, useEffect } from 'react';
import { matchTag } from '@portal-internet/core';
import { getDirecte } from 'utils/canals';
import Capcalera from './Capcalera';
import Cos from './Cos';
import MediaDestacat from './MediaDestacat';
import PuntsClau from './PuntsClau';
import StickyHeader from './StickyHeader';
import styles from './itemnoticia.module.scss';
import ModulDestacatVisual from '../ModulDestacatVisual';

const ItemNoticia = (props) => {
    const { cos, className, puntsClau, tags, id, mediadestacats, audios, canalsDirectesEmbedats } = props;
    const [isPreview, setIsPreview] = useState(false);

    useEffect(() => {
        function getPreviewStatus() {
            if (typeof window === 'undefined') {
                return false;
            }
            const currentUrl = window.location.href;

            return currentUrl.includes('preview=true');
        }
        setIsPreview(getPreviewStatus());
    }, []);

    const stylesNoticia = clsx({
        [styles.itemnoticia]: true,
        [styles.preview]: isPreview,
        [styles[className]]: !__isEmpty(className)
    });

    const isTagInternacional = matchTag(tags, 'INTERNACIONA');

    let existMediaDestacatAudio = false;
    if (!__isEmpty(canalsDirectesEmbedats)) {
        const canalDirecte = getDirecte(canalsDirectesEmbedats);
        if (canalDirecte && canalDirecte?.tipus === 'audio') {
            existMediaDestacatAudio = true;
        }
    } else if (mediadestacats === 'AUDIO' && !__isEmpty(audios)) {
        existMediaDestacatAudio = true;
    }

    return (
        <article key={`item-noticia-${id}`} className={stylesNoticia} data-testid='item-noticia'>
            <Capcalera {...props} />
            <StickyHeader {...props}>
                <MediaDestacat {...props} />
                <PuntsClau cos={puntsClau} />
                {!existMediaDestacatAudio && isTagInternacional && (
                    <div className={styles.modulDestacatVisualButlleti}>
                        <ModulDestacatVisual
                            estils='p-300 p-mobile-200 mb-550'
                            background={{
                                color: '#ff8135'
                            }}
                            titol={{
                                text: 'Butlletí Mirada Global',
                                color: '#111617',
                                fontSize: '--font-size-body-xl',
                                lineHeight: '--font-height-body-xl',
                                fontWeight: '700'
                            }}
                            subtitol={{
                                text: 'Cada divendres al teu correu, un article gratuït per entendre cap a on va el món',
                                color: '#111617',
                                fontSize: '--font-size-body-m',
                                fontWeight: '400',
                                lineHeight: '--font-height-body-m'
                            }}
                            icon={{
                                gap: '--spacing-space-200',
                                url: 'https://statics.3cat.cat/recursos/3catinfo/img/ic_sobre.png',
                                position: 'left',
                                width: '40',
                                height: '40',
                                widthMobile: '32',
                                heightMobile: '32',
                                size: '32'
                            }}
                            boto={{
                                estils: 'negre',
                                textColor: '#FFFFFF',
                                borderColor: '#111617',
                                backgroundColor: '#111617',
                                textColorHover: '#111617',
                                borderColorHover: '#111617',
                                backgroundColorHover: 'transparent',
                                position: 'left',
                                text: 'El vull rebre',
                                url: '/butlletins/3catinfo/50/',
                                fontSize: '--font-size-body-m',
                                fontWeight: '700',
                                container: 'right'
                            }}
                        />
                    </div>
                )}
                <Cos cos={cos} />
            </StickyHeader>
        </article>
    );
};

export default ItemNoticia;
